import React, { MouseEventHandler, ReactElement, ReactNode } from 'react';
import cn from 'clsx';

import AltButtonGroup from './components/alt-button-group/alt-button-group';
import Link from '../link/link';

import styles from './alt-button.scss';

interface AltButtonProps {
  children: ReactNode | Array<ReactNode>;
  className?: string;
  href?: string;
  icon: React.ElementType;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

function AltButton(props: AltButtonProps) {
  const { children, className = '', href, icon: Icon, onClick } = props;
  let component: ReactElement;

  if (href) {
    component = (
      <Link
        className={cn(styles['container'], `alt-button ${className}`)}
        to={href}
      >
        <>
          <Icon className={styles['icon']} />
          {children}
        </>
      </Link>
    );
  } else {
    component = (
      <button
        className={cn(styles['container'], `alt-button ${className}`)}
        onClick={onClick}
        type="button"
      >
        <Icon className={styles['icon']} />
        {children}
      </button>
    );
  }
  return component;
}

export { AltButtonGroup };
export default AltButton;
